import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormArray, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BASE_IMAGE_URL } from 'src/app/endpoints';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { SafeUrlPipe } from 'src/app/shared/pipe/safe_url/safe_url_pipe.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import JsBarcode from 'jsbarcode';
import { MatCardModule } from '@angular/material/card';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
declare var bootstrap: any;

@Component({
  selector: 'app-assign-sample-to-dis',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterLink,
    MatTabsModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    MatIcon,
    MatCardModule,
    NgClass
  ],
  templateUrl: './assign-sample-to-dis.component.html',
  styleUrl: './assign-sample-to-dis.component.scss'
})
export class AssignSampleToDisComponent {

  startpoint: number = 0;
  search: any;
  totalLoaded: number = 0;
  total: any;
  pageNo: any;
  sampleId: any;
  name: any;

  dataSource = new MatTableDataSource<any>([]);

  constructor(
    private sampleService: SampleService,
    private categoryService: CategoryService,
    private companyService: CompanyService,
    public userDataService: UserDataService,
    public userService: UserServiceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.setDisplayedColumns();
  }

  displayedColumns: string[] = [];

  setDisplayedColumns(): void {
    this.displayedColumns = [
      'name',
      'stock',
      'action',
    ];
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) wholeSalerPaginator: MatPaginator;
  @ViewChild(MatPaginator) retailerPaginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;

  sampleData: any;
  wholeSalerTotal: any;
  retailerTotal: any;

  allCategoriesMini: any;

  issueSampleForm = new FormGroup({
    rows: new FormArray([])
  });

  get rows() {
    return this.issueSampleForm.get('rows') as FormArray;
  }

  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;
  sampleSearch: any = {
    name: '',
    barCode: '',
    category: undefined,
    company: undefined,
    startdate: null,
    enddate: null
  };


  isCompanyLoggedIn: boolean = false

  getCompanyData() {
    let userData = this.userDataService.getData()
    let companyData = userData.company
    if (!!companyData) {
      this.isCompanyLoggedIn = true
      this.sampleSearch.company = companyData._id
      this.getAllSamples(null)
    }
    else {
      this.isCompanyLoggedIn = false
      this.getAllSamples(null);
    }
  }

  distributorId: any
  distributorType: any
  ngOnInit(): void {
    this.distributorId = this.activatedRoute.snapshot.paramMap.get("distributorId")
    this.distributorType = this.activatedRoute.snapshot.paramMap.get("distributorType");
    this.getAllCategoriesMini()
    this.allCompaniesMini()
    this.getCompanyData()
    this.getSingleDistributor()
  }

  distributorData: any
  getSingleDistributor(): void {
    if (!this.distributorId) return;
    this.spinner.show();
    this.userService.singleDistributor({ _id: this.distributorId }).subscribe({
      next: (res: any) => {
        if (res.success) this.distributorData = res.data;
      },
      error: (e) => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }

  sampleFilter(event: any): void {
    this.getAllSamples(null);
  }

  getAllCategoriesMini(): void {
    this.categoryService.allCategoriesMini({}).subscribe({
      next: (res) => {
        if (res.success) this.allCategoriesMini = res.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.sampleSearch.name = name || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  onBarCodeInputChange(event: any): void {
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      const code = event.target.value.trim();
      this.sampleSearch.barCode = code || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  clearDateRange(): void {
    this.sampleSearch.startdate = null;
    this.sampleSearch.enddate = null;
    this.getAllSamples(null);
  }




  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath;
  }

  allCompanies: any

  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  getSingleSample(sampleId: any) {
    this.spinner.show();
    this.sampleService.singleSample({ _id: sampleId }).subscribe({
      next: (v: any) => {
        if (v.success) this.sampleData = v.data;
        else console.log(v.message);
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => this.spinner.hide()
    });
  }

  getAllSamples(event: any) {
    this.spinner.show();
    if (event == null) {
      this.dataSource.data = [];
    }
    let data: any = {
      startpoint: this.startpoint,
      name: this.sampleSearch.name || undefined,
      sampleCode: this.sampleSearch.barCode || undefined,
      categoryId: this.sampleSearch.category || undefined,
      startdate: this.sampleSearch.startdate || undefined,
      enddate: this.sampleSearch.enddate || undefined,
      companyId: this.sampleSearch.company || undefined
    };

    if (this.totalLoaded == 0 || event == null || ((this.totalLoaded < this.total) && (event.pageIndex > this.pageNo))) {
      this.sampleService.allSamples(data).subscribe({
        next: (result) => {
          this.spinner.hide();
          if (result.success) {
            this.total = result.total ?? 0;
            this.dataSource.data = [...this.dataSource.data, ...(result.data || [])];
            this.totalLoaded = this.dataSource.data.length;
          }
        },
        error: (e: any) => {
          this.spinner.hide();
          const errorMsg = e.status === 0
            ? "Server not reachable. Try again later."
            : e.message || 'An unexpected error occurred.';
          this.toastr.error(errorMsg, 'Error');
        },
        complete: () => this.spinner.hide()
      });
    } else this.spinner.hide();
  }


  assignSampleForm = new FormGroup({
    sampleList: new FormArray<FormGroup>([])
  });

  get sampleList(): FormArray {
    return this.assignSampleForm.get('sampleList') as FormArray;
  }

  selectAllSamples() {
    this.dataSource?.data?.forEach(sample => {
      this.assignSample(sample);
    });
  }
  assignedSamples: any[] = [];
  assignSample(sample: any) {

    this.sampleService
      .selectSampleForIssue({ distributorId: this.distributorId, sampleId: sample._id })
      .subscribe(
        (res: any) => {
          const alreadyAdded = this.assignedSamples.find(s => s._id === sample._id);
          if (alreadyAdded) return;

          const distributorLimit = res.success && res.data?.distributorLimit
            ? res.data.distributorLimit
            : (this.distributorType === 1
              ? sample.maxIssueQuantityWholesaler
              : sample.maxIssueQuantityRetailer);
          const previousAssigned = res.success && res.data?.quantityAssigned ? res.data.quantityAssigned : 0;
          const remainingQty = res.success && res.data?.quantityRemaining ? res.data.quantityRemaining : 0;

          this.assignedSamples.push({
            ...sample,
            previousAssigned,
            remainingQty
          });

          this.sampleList.push(
            new FormGroup({
              sampleId: new FormControl(sample._id),
              quantityAssigned: new FormControl(0, [Validators.required, Validators.min(1), Validators.max(distributorLimit)]),
              distributorLimit: new FormControl(
                distributorLimit,
                [Validators.required, Validators.min(distributorLimit)]
              )
            })
          );
        },
        (err: any) => {
          const alreadyAdded = this.assignedSamples.find(s => s._id === sample._id);
          if (alreadyAdded) return;
          const distributorLimit = this.distributorType === 1
            ? sample.maxIssueQuantityWholesaler
            : sample.maxIssueQuantityRetailer;

          this.assignedSamples.push({
            ...sample,
            previousAssigned: 0,
            remainingQty: 0
          });
          this.sampleList.push(
            new FormGroup({
              sampleId: new FormControl(sample._id),
              quantityAssigned: new FormControl(0, [Validators.required, Validators.min(1), Validators.max(distributorLimit)]),
              distributorLimit: new FormControl(
                distributorLimit,
                [Validators.required, Validators.min(distributorLimit)]
              )
            })
          );
        }
      );
  }


  removeSample(index: number) {
    this.assignedSamples.splice(index, 1);
    this.sampleList.removeAt(index);
  }

  failedSamples: any[] = [];


  submit() {
    this.spinner.show();
    if (this.assignSampleForm.invalid) return;

    const payload = {
      receiverType: this.distributorType,
      companyId: this.sampleSearch.company,
      receiverDistributorId: this.distributorId,
      sampleList: this.assignSampleForm.value.sampleList
    };

    this.sampleService.checkMultipleSampleBeforeIssue(payload).subscribe({
      next: (v: any) => {
        this.spinner.hide();
        if (v.success) {
          if (Array.isArray(v.failed) && v.failed.length > 0) {
            for (const sample of this.assignedSamples) {
              sample.error = null;
            }
            for (const failed of v.failed) {
              const failedId = failed?.data?.sampleId;
              const errorMessage = failed?.message;
              for (const sample of this.assignedSamples) {
                if (sample._id === failedId) {
                  sample.error = errorMessage;
                  break;
                }
              }
            }
            return;
          }

          this.sampleService.issuedMultipleSampleToDis(payload).subscribe({
            next: (res: any) => {
              this.spinner.hide();

              if (res.success && Array.isArray(res.successful) && res.successful.length > 0) {
                const assignedRows = res.successful
                  .filter(item => item.success)
                  .map((item, index) => {
                    const name = item.message || 'Sample';
                    return `
                                <tr>
                                  <td style="padding: 6px;">${index + 1}.</td>
                                  <td style="padding: 6px;">${name}</td>
                                </tr>`;
                  })
                  .join('');

                const assignedHTML = `
                      <div style="font-size: 16px; display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
                        <div><b>Assigned to ${this.distributorData?.name || 'Distributor'}</b></div>
                        <i class="bi bi-check-circle-fill" style="color: green; font-size: 20px;"></i>
                      </div>

                      <div style="max-height: 250px; overflow-y: auto; font-size: 14px;">
                        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;" class="table-bordered">
                          <thead>
                            <tr style="background-color: #f0f0f0; border-bottom: 1px solid #ccc;">
                              <th style="text-align: center; padding: 6px;">#</th>
                              <th style="text-align: center; padding: 6px;">Sample Name - QTY</th>
                            </tr>
                          </thead>
                          <tbody>
                            ${assignedRows}
                          </tbody>
                        </table>
                                  </div>`;

                Swal.fire({
                  html: assignedHTML,
                  showCancelButton: false,
                  showCloseButton: false,
                  confirmButtonText: 'OK'
                });

                (this.assignSampleForm.get('sampleList') as FormArray).clear();
                this.assignedSamples = [];
                this.toastr.success(res.message, 'Success');
                this.getAllSamples(null);

              } else {
                this.toastr.error(res.message || 'No samples assigned.', 'Error');
              }


            }
            ,
            error: (e: any) => {
              this.spinner.hide();
              this.toastr.error(e.message, 'Error');
            },
            complete: () => {
              this.spinner.hide();
            }
          });
        } else {
          this.spinner.hide();
          this.toastr.error(v.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

  changeLimit(index:any,sampleData:any){

          const limit = (this.sampleList.at(index)?.get('distributorLimit')?.value)??0;
          const leftSamples = sampleData.leftItems;
          const control = this.sampleList.at(index).get('quantityAssigned');

          if (limit > leftSamples) {
            control.setValidators([Validators.max(leftSamples),Validators.min(1),Validators.required]);
          } else {
            control.setValidators([Validators.max(limit),Validators.min(1),Validators.required]);
          }

          control.patchValue(0);
          control.updateValueAndValidity();
  }







}
